import React, {Component} from 'react';
import NavBar from "./NavBar";
import Footer from "./Footer";
import Logo from "./Logo";

import NexusDeviceDark from "./NexusDeviceDark";
import NexusDeviceLight from "./NexusDeviceLight";
import screenRigChecksCreate from '../images/screenshot_rigcheck_create.png';
import screenInventory from '../images/screenshot_inventory.png';
import screenLanding from '../images/screenshot_landing.jpg';
import screenEmpty from '../images/screenshot_empty.png';
import screenAmbulances from '../images/screenshot_ambulances.png';

class Home extends Component {

    livechat;

    componentDidMount() {
        document.title = "RigChecks";
    }

    render() {
        return (
            <div>
                <NavBar/>

                <div
                    className="jumbotron-fluid position-relative overflow-hidden py-5 py-md-5 my-md-3 text-center bg-secondary bg-pattern">
                    <div className="pt-5 pb-3"/>

                    <div className="product-device-nexus d-none d-md-block animated fadeIn">
                        <NexusDeviceLight imageSrc={screenAmbulances}/>
                    </div>
                    <div className="product-device-nexus product-device-nexus-2 d-none d-md-block animated fadeIn">
                        <NexusDeviceDark imageSrc={screenLanding}/>
                    </div>


                    <div className="pt-5 mt-5 product-device-absolute d-md-none animated fadeIn">
                        <NexusDeviceLight imageSrc={screenEmpty} width={"100%"}/>
                    </div>
                    <div className="d-md-none col-lg-5 py-lg-5 mx-auto my-5 pt-5">
                        {/*<div style={{maxWidth:"250px"}}>*/}
                        <Logo width={"80px"} height={"80px"}/>
                        <h2 className="text-primary font-weight-normal">Save Time. Save Lives.</h2>
                        <p className="text-light lead font-weight-light">
                            An easier way to do inventory
                            <br/>
                            management & equipment checks
                            <br/>
                            for EMT's on the go.
                        </p>
                        <a className="btn btn-primary" href="https://dashboard.rigchecksems.com/signup">
                            Signup your team
                        </a>
                        <br/>
                        <br/>
                        <div className="btn-group" role="group" aria-label="">
                            <a className="btn btn-secondary" target="_blank" rel="noopener noreferrer"
                               href="https://play.google.com/store/apps/details?id=com.rigchecks.app&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                                <i className="fa fa-android text-success"></i> Android
                            </a>
                            <a className="btn btn-secondary">
                                <i className="fa fa-apple text-muted"></i> iOS (Coming soon)
                            </a>
                        </div>
                        {/*</div>*/}
                    </div>

                    <div className="d-none d-md-block col-lg-5 py-lg-5 mx-auto my-5 pt-5 bg-gradient">
                        {/*<div style={{maxWidth:"250px"}}>*/}
                        <Logo width={"80px"} height={"80px"}/>
                        <h2 className="text-primary font-weight-normal">Save Time. Save Lives.</h2>
                        <p className="d-none d-md-block lead font-weight-light">
                            An easier way to do inventory
                            <br/>
                            management & equipment checks
                            <br/>
                            for EMT's on the go.
                        </p>

                        <a className="btn btn-primary" href="https://dashboard.rigchecksems.com/signup">
                            Signup your team
                        </a>
                        <br/>
                        <br/>
                        <div className="btn-group" role="group" aria-label="">
                            <a className="btn btn-secondary" target="_blank" rel="noopener noreferrer"
                               href="https://play.google.com/store/apps/details?id=com.rigchecks.app&amp;pcampaignid=MKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1">
                                <i className="fa fa-android text-success"></i> Android
                            </a>
                            <a className="btn btn-secondary">
                                <i className="fa fa-apple text-muted"></i> iOS (Coming soon)
                            </a>
                        </div>
                        {/*</div>*/}
                    </div>

                    <div className="pt-5 pb-3"/>
                    <div className="pt-5 pb-3"/>
                </div>

                <div className="d-md-flex flex-md-equal w-100 my-md-3 pl-md-3">
                    <div
                        className="bg-primary mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center text-white overflow-hidden box-shadow device-card">
                        <div className="my-3 py-3">
                            <h2 className="display-5">Manage inventory</h2>
                            <p className="lead">Manage inventory and keep track of all the items your crew uses. You can
                                even organize items by category.</p>
                        </div>
                        <div className="mx-auto"
                             style={{width: "80%", height: "400px", borderRadius: "21px 21px 0 0"}}>
                            <NexusDeviceLight imageSrc={screenInventory}/>
                        </div>
                    </div>
                    <div
                        className="bg-light mr-md-3 pt-3 px-3 pt-md-5 px-md-5 text-center overflow-hidden box-shadow device-card">
                        <div className="my-3 py-3">
                            <h2 className="display-5">Simple, straight forward Rigchecks</h2>
                            <p className="lead">Doing a rigcheck is as easy as swiping left. Add numbers to keep track
                                of how many items the truck has and more!</p>
                        </div>
                        <div className="mx-auto"
                             style={{width: "80%", height: "400px"}}>
                            <NexusDeviceDark imageSrc={screenRigChecksCreate}/>
                        </div>
                    </div>
                </div>
                <div className="d-md-flex flex-md-equal w-100 my-md-3 pl-md-3">

                </div>
                <div className="jumbotron text-center">
                    <a className="btn btn-primary" href="/features">Explore Features</a>
                </div>

                <Footer/>
            </div>
        )
    }

}

export default Home;




// WEBPACK FOOTER //
// ./src/component/Home.js